import { EmitterContext, EmitterSettings } from '@/contexts/emitter/helpers';
import { useContext } from 'react';

const useEmitter = () => useContext<EmitterSettings>(EmitterContext);

export default useEmitter;
